// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O335","colBig":"styles_colBig__3trmA","colSmall":"styles_colSmall__23WN6"};